import { type Id, toast, type UpdateOptions } from "vue3-toastify/dist/index.mjs";

export default toast;
export type { ToastContainerOptions } from "vue3-toastify/dist/index.mjs";

/**
 * Settles a toast created with `toast.loading()` into its final success/failure state.
 *
 * `toast.loading()` forces `closeOnClick`, `closeButton` and `draggable` off so a spinner cannot be dismissed
 * while the work is still running, and `toast.update()` carries those over unless they are passed again. A
 * settled toast updated without them cannot be dismissed by any means — which strands an `autoClose: false`
 * failure on screen until the page is reloaded.
 * @param toastId
 * @param options
 */
export const settleLoadingToast = (toastId: Id, options: UpdateOptions): void => {
  toast.update(toastId, {
    isLoading: false,
    closeOnClick: true,
    closeButton: true,
    draggable: true,
    ...options,
  });
};

export const raiseToastsAbove = (zIndex: number): void => {
  document.documentElement.style.setProperty("--toastify-z-index", String(zIndex));

  const $container = document.querySelector<HTMLElement>(".Toastify");
  // lastChild, not lastElementChild: a Teleport's anchor is a text node, and its content can render after this.
  if ($container !== null && document.body.lastChild !== $container) {
    document.body.appendChild($container);
  }
};
